import {GET_USER_LOGIN_STATUS, GET_USER_LOGIN_STATUS_START, SESSION_EXPIRED} from "./LoginActions";

const INITIAL_STATE = {isLogin: false, fetching: true, email: ''};

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case GET_USER_LOGIN_STATUS_START:
            return {...state, fetching: true};
        case GET_USER_LOGIN_STATUS:
            if(action.error) {
                return {...INITIAL_STATE, fetching: false}
            }
            return {...state, ...action.payload.data, isLogin: true, fetching: false};
        case SESSION_EXPIRED:
            return {...state, fetching: false, isLogin: false};
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/containers/login/LoginReducer.js